// Shared base path for all BYOD API endpoints
export const BYOD_API_BASE = 'analytics/byod';

// ── Queries ───────────────────────────────────────────────────────────────────
export {useDashboardList} from './queries/useDashboardList';
export {useReportList} from './queries/useReportList';
export {useLoadDashboard} from './queries/useLoadDashboard';
export {useWidgetCatalog} from './queries/useWidgetCatalog';
export {useWidgetDetail} from './queries/useWidgetDetail';
export type {WidgetDetail} from './queries/useWidgetDetail';
export {useFilterOptions} from './queries/useFilterOptions';
export {useFilterDefinitions} from './queries/useFilterDefinitions';
export {useTileData, BYOD_TILE_QUERY_KEY} from './queries/useTileData';
export type {UseTileDataResult} from './queries/useTileData';

// ── Mutations ─────────────────────────────────────────────────────────────────
export {useSaveAndPublish} from './mutations/useSaveAndPublish';
export type {SaveAndPublishResponse} from './mutations/useSaveAndPublish';
export {useSetDefaultDashboard} from './mutations/useSetDefaultDashboard';
export {useDeleteDashboard} from './mutations/useDeleteDashboard';
export {useSetGroupDefaultDashboard} from './mutations/useSetGroupDefaultDashboard';
